import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.less';
import plugins from '../src/plugins' // plugins
 // 分页组件
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)
Vue.use(Vant);
Vue.use(plugins)
import '@/assets/js/mobileMessage.js'
Vue.use(ElementUI);
Vue.config.productionTip = false
// 移动端特殊处理（禁止缩放等）
import {isMobile} from '@/components/util/equipmentUtil.js'
if (isMobile) {
  require('./assets/js/flexible.js')
}
// 地图
import AMapLoader from '@amap/amap-jsapi-loader'
AMapLoader.load({
  key: '2044c0e231169c319ed9f47b5c7ffa18', // 高德地图开发者平台申请的key放入此处
  version: '2.0', // 指定要加载的JSAPI版本，缺省为1.4.15
  plugins: ['AMap.Scale'] // 要加载的插件列表
}).then(AMap => {
  Vue.use(AMap)
  Vue.prototype.$AMap = AMap
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
